import { React } from 'react';
import ServiceSection from '../../../../ServiceSection/ServiceSection';
import HighlightBanner from '../../../../HighlightBanner/HighlightBanner';
import SatelliteText from '../../../SatelliteText/SatelliteText';

// "5 questions" box: same yellow highlight box and square-bullet list as the consultancy page benefits
const CustomVsStandardSoftware7 = props => {
    const questions = Object.keys(props.t('customVsStandardSoftware:questions.list', { returnObjects: true }));
    return (
        <ServiceSection noPadTop noPadBottom noTitle noImg {...props} page="customVsStandardSoftware" section="questions">
            <HighlightBanner services {...props} page="customVsStandardSoftware" section="questions">
                <div className='TextGroup'>
                    <div className='container-custom text-container'>
                        <p className='noPad'>{props.t('customVsStandardSoftware:questions.text')}</p>
                    </div>
                    <div className='container-custom text-container'>
                        <ul className='list description satellite-questions'>
                            {questions.map(question => (
                                <div key={question} className='content-items'>
                                    <h3>
                                        <li>{props.t('customVsStandardSoftware:questions.list.' + question)}</li>
                                    </h3>
                                </div>
                            ))}
                        </ul>
                    </div>
                </div>
            </HighlightBanner>
            <div className='TextGroup Satellite'>
                <div className='container-custom subtitle'>
                    <SatelliteText t={props.t} prefix="customVsStandardSoftware:questions.after" first noPadBottom />
                </div>
            </div>
        </ServiceSection>
    );
};

export default CustomVsStandardSoftware7;
